import React from 'react';

/**
 * DexScreener Chart Modal
 * Displays an embedded DexScreener chart in a modal overlay
 */
export default function DexScreenerModal({ isOpen, onClose, chain, tokenAddress, tokenSymbol }) {
  if (!isOpen) return null;

  // DexScreener embed URL format
  const embedUrl = `https://dexscreener.com/${chain}/${tokenAddress}?embed=1&theme=dark&trades=0&info=0`;

  return (
    <div
      className="fixed inset-0 z-50 overflow-hidden"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-75 transition-opacity" />

      {/* Modal Container */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="relative bg-gray-900 rounded-lg shadow-2xl w-full max-w-6xl h-[80vh] flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-4 py-3 border-b border-gray-700">
            <div className="flex items-center gap-3">
              <span className="text-white font-semibold text-lg">
                {tokenSymbol || 'Chart'}
              </span>
              <a
                href={`https://dexscreener.com/${chain}/${tokenAddress}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs px-2 py-1 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
              >
                Open in DexScreener
              </a>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white transition-colors p-1"
              title="Close"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Chart iframe */}
          <div className="flex-1 relative">
            <iframe
              src={embedUrl}
              title={`DexScreener Chart - ${tokenSymbol}`}
              className="absolute inset-0 w-full h-full border-0"
              allow="clipboard-write"
              loading="lazy"
            />
          </div>

          {/* Footer with quick actions */}
          <div className="flex items-center justify-between px-4 py-2 border-t border-gray-700 bg-gray-800">
            <div className="text-xs text-gray-400 dark:text-gray-500 font-mono">
              {tokenAddress}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => navigator.clipboard.writeText(tokenAddress)}
                className="text-xs px-3 py-1 bg-gray-700 text-gray-300 rounded hover:bg-gray-600 transition-colors"
              >
                Copy CA
              </button>
              {chain === 'solana' && (
                <a
                  href={`https://axiom.trade/t/${tokenAddress}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs px-3 py-1 bg-purple-600 text-white rounded hover:bg-purple-700 transition-colors"
                >
                  Trade on Axiom
                </a>
              )}
              {chain === 'base' && (
                <a
                  href={`https://gmgn.ai/base/token/${tokenAddress}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                >
                  Trade on GMGN
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
